export enum FilterType {
  Channels = 'Channels',
  UpcomingStreams = 'UpcomingStreams',
  PastStreams = 'PastStreams',
  Videos = 'Videos'
}
